<header>
    <h3>{{ 'pages.profile.addresses.renameTitle' | translate }}</h3>
    <button mat-icon-button aria-label="Close" (click)="cancel()">
        <span class="icon-close"></span>
    </button>
</header>

<div class="dialog-content">
    <label class="input-label">{{ 'pages.profile.addresses.renamePrompt' | translate }}</label>
    <input
        class="name-input"
        type="text"
        [formControl]="nameControl"
        (keyup.enter)="confirm()"
        autofocus />
    <div class="error-msg" *ngIf="nameControl.touched && nameControl.hasError('minlength')">
        {{ 'pages.profile.addresses.renameMinLength' | translate }}
    </div>
</div>

<footer>
    <button
        class="bciti-button bciti-button--blue-inversed"
        (click)="cancel()">
        {{ 'pages.residences.reviewDialog.cancelButton' | translate }}
    </button>
    <button
        class="bciti-button bciti-button--blue"
        [disabled]="!nameControl.valid"
        (click)="confirm()">
        {{ 'pages.profile.addresses.renameButton' | translate }}
    </button>
</footer>
